import { svgIconStrictSizes } from './types';
export function isSvgIconStrictSize(size) {
    return typeof size === 'string' && svgIconStrictSizes.includes(size);
}
